import { render, staticRenderFns } from "./mixed1.vue?vue&type=template&id=c4870382"
import script from "./mixed1.vue?vue&type=script&lang=js"
export * from "./mixed1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports